import { millisecondsInWeek as f } from "./constants.js";
import { startOfWeek as m } from "./startOfWeek.js";
import { startOfWeekYear as a } from "./startOfWeekYear.js";
import { toDate as i } from "./toDate.js";
function k(r, t) {
  const e = i(r), o = +m(e, t) - +a(e, t);
  return Math.round(o / f) + 1;
}
export {
  k as default,
  k as getWeek
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getWeek.js
// module id = 848
// module chunks = 41